<template>
  <div class="flex flex-col overflow-hidden">
    <div class="border-b border-gray-200">
      <nav class="flex flex-wrap gap-x-6 gap-y-0 px-4" aria-label="Tabs">
        <router-link
          v-for="tab in tabs"
          :key="tab.route"
          :to="{ name: tab.route }"
          :class="[
              isActiveTab(tab.route)
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition'
            ]">
          <i :class="tab.icon + ' text-sm'"></i>
          <span>{{ tab.name }}</span>
        </router-link>
      </nav>
    </div>

    <!-- Tab Content -->
    <div class="flex flex-col p-2">
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";

const route = useRoute()

const tabs = [
  // {
  //   name: "Business Names",
  //   route: "business-name-registry",
  //   icon: "fa-solid fa-database"
  // },
  // {
  //   name: "Companies",
  //   route: "company-registry",
  //   icon: "fa-solid fa-database"
  // },
  // {
  //   name: "Building Societies",
  //   route: "building-society-registry",
  //   icon: 'fa-solid fa-database'
  // },
  {
    name: 'Non Individuals',
    route: 'nonindividual-registry',
    icon: 'fa-solid fa-database'
  },
  {
    name: 'Documents',
    route: 'documents-registry',
    icon: 'fa-solid fa-database'
  },
  {
    name: 'MDAs',
    route: 'mda-registry',
    icon: 'fa-solid fa-database'
  },
  {
    name: 'Black List',
    route: 'blacklist-registry',
    icon: 'fa-solid fa-database'
  },
  {
    name: 'DeRegistered',
    route: "de-registered-registry",
    icon: 'fa-solid fa-database'
  },
  {
    name: 'Practitioners',
    route: 'practitioners-registry',
    icon: 'fa-solid fa-database'
  },
]

const isActiveTab = (tabRoute: string) => {
  return route.name === tabRoute
}

// Simple router-view wrapper component
</script>
